// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M8.6 8C8.6 8.33 8.33 8.6 8 8.6C7.67 8.6 7.4 8.33 7.4 8C7.4 7.67 7.67 7.4 8 7.4C8.33 7.4 8.6 7.67 8.6 8Z',
];
